import INFTCollections from '../../models/INFTCollections'

import AvaxPudgyPenguinsLogo from '../../../../assets/nft-logo/AvaxPudgyPenguins.jpg'
import PudgyPenguinsCard from '../../nftFormats/PudgyPenguins/Card/PudgyPenguinsCard'
import PudgyPenguinsDetail from '../../nftFormats/PudgyPenguins/Detail/PudgyPenguinsDetail'
import PudgyPenguinsActivityDetail from '../../nftFormats/PudgyPenguins/Activity/PudgyPenguinsActivityDetail'

export const AvaxPudgyPenguinsData: INFTCollections[] = [
  {
    id: 'AvaxPudgyPenguins',
    tokenAddress: '0xFc7eF1f2Be7848ECA4234a1225e798FaF80D248d',
    name: 'Avax Pudgy Penguins',
    cardFormat: PudgyPenguinsCard,
    detailFormat: PudgyPenguinsDetail,
    activityFormat: PudgyPenguinsActivityDetail,
    category: 1,
    creatorAddress: '0x980B2205dCBa5528aa72C556a10794f0698647D3',
    logo: AvaxPudgyPenguinsLogo,
    website: 'https://www.avaxpudgypenguins.com/',
    twitter: 'PenguinsOnAVAX',
    telegram: 'https://t.me/joinchat/8O4wBiD70wVmN2Nk',
    discord: 'https://discord.com/invite/dnF4ww6sHW',
    forkProject: true
  }
]

export const AvaxPudgyPenguinsCategoryData = {
  [AvaxPudgyPenguinsData[0].tokenAddress.toLowerCase()]: AvaxPudgyPenguinsData[0].category
}
